import React,{Component} from 'react';
import FeedbackOption from './FeedbackItems/FeedbackOption';
import { withLastLocation } from "react-router-last-location";
import { trackEvent } from '../../../helpers/analyticsHelper';
import { PAGE_EVENT_NAMES, FEEDBACK_QUESTION_TYPE } from '../../../constants/common';
import  Feedback  from './Feedback';
import { toTitleCase } from '../../../helpers/helper';

export class FeedbackMain extends Component {

    constructor(props){
        super(props);
        this.state={
            answers: null,
            question: null,
            questionId: null,
            questionType: null,
            otherText:'',
            loadingThankyouPage: false,
            submitDisabled: true,
            textboxDisabled:true,
            checkboxArray:[],
            indexOther: null,
            userFirstName: null,
            optionChecked : null,
            buttonDisabled: true,
            feedbackStrings: {
                SUCCESS_MESSAGE: null,
                CHOOSE_ALL:null
            },
            mixpanelProperties: {
                type: null,
                feedbacks: [],
                comment: ""
            }
        }
    }

    componentDidMount(){
        if(this.props.feedbackData && this.props.translations) {
            this.setState({
                question: this.props.feedbackData[0].question,
                questionId: this.props.feedbackData[0].questionNumber,
                answers: this.props.feedbackData[0].answers,
                questionType: this.props.feedbackData[0].questionType,
                submitDisabled: this.props.feedbackData[0].questionType !== FEEDBACK_QUESTION_TYPE.FREE_RESPONSE,
                userFirstName: this.props.userObj.details.firstName && toTitleCase(this.props.userObj.details.firstName),
                feedbackStrings: {
                    SUCCESS_MESSAGE: this.props.translations.data["FEEDBACK.SUCCESS_MESSAGE"],
                    CHOOSE_ALL: this.props.feedbackData[0].questionType ===  FEEDBACK_QUESTION_TYPE.FREE_RESPONSE ?  this.props.translations.data["FEEDBACK.ENTER_TEXT_BELOW"] : this.props.translations.data["FEEDBACK.CHOOSE_ALL"]
                }
            })
        }
    }

    componentDidUpdate(){
        if(this.state.answers && !this.state.optionChecked ){
            let obj = {};
            let lastIndex = this.state.answers.length;
            this.state.answers.map((ele,i)=>{
                let index = i+1;
                return (obj = {
                    ...obj,
                    [index] : false
                     })
                }
            )
            this.setState(
                {optionChecked:obj,
                indexOther:lastIndex});
        }
    }
    
    checkboxClick = (id)=> {
        let check = this.state.optionChecked;
        check[id] = !(check[id]);
    
        if(check[id] === true) {
            if(id==this.state.indexOther){
                this.setState({textboxDisabled:false});
            }
            this.state.checkboxArray.push(check[id]);
        }
        else{
            if(id==this.state.indexOther){
                this.setState({textboxDisabled:true, otherText: ''});
            }
            this.state.checkboxArray.pop();
        }
       
        this.setState({optionChecked: check});

        if(this.state.checkboxArray.length >0) {  
            this.setState({submitDisabled:false});
        }
        else if(this.state.checkboxArray.length ===0) {
            this.setState({submitDisabled:true});
        }

    }

    textboxHandler = (event)=> {
        this.setState({otherText: event.target.value});   
    }

    buttonDisableHandler = (list)=> {
        return this.state.submitDisabled || 
            (((list && list[this.state.indexOther]) || this.state.questionType === FEEDBACK_QUESTION_TYPE.FREE_RESPONSE) && this.state.otherText.length === 0);
    }

    onSubmit=()=>{
        this.setState({loadingThankyouPage: true});
        let responses = [];
        let comment='';
        let data ={
            questionId: this.state.questionId,
            questionText: this.state.question,
            answerResponse: []

        };
        if (this.state.questionType === FEEDBACK_QUESTION_TYPE.FREE_RESPONSE) {
            let text = this.state.otherText;

            data.answerResponse.push({
                answerId: 1,
                answerText: text
            });

            trackEvent(this.props.userObj.details.uuid, PAGE_EVENT_NAMES.FEEDBACK , {
                type: this.props.queryParams.feedbackType,
                feedbacks: text,
                comment: text,
                question: this.state.questionId
            })
        }else {
            Object.keys(this.state.optionChecked).map(index=>{
                if(this.state.optionChecked[index]) {
                    let ans = {
                        "answerId" : this.state.answers[index-1].answerId,
                        "answerText": index == this.state.indexOther ? this.state.otherText : this.state.answers[index-1].answer
                    };
                    comment = index == this.state.indexOther ? ans.answerText : '';

                    data.answerResponse.push(ans);
                    responses.push(`'`+ ans.answerText + `'`);
                }
            });
            trackEvent(this.props.userObj.details.uuid, PAGE_EVENT_NAMES.FEEDBACK , {
                type: this.props.queryParams.feedbackType,
                feedbacks: responses.toString(),
                comment: comment,
                question: this.state.questionId
            })
        }
        
        this.props.onSubmit([data]);
}

    render() {    
        let feedbackOptions = null;
        if(this.state.answers != null && this.state.optionChecked){
            feedbackOptions = this.state.answers.map(answer=> {
                return <FeedbackOption 
                    option={answer.answer} 
                    key={answer.answerId} 
                    id={answer.answerId} 
                    onClick={()=>this.checkboxClick(answer.answerId)}
                    handleCheck={this.state.optionChecked[answer.answerId]}
                />
                     
            })
        }
        let submitButton =(
             <button type="submit" 
                     className="submit-btn" 
                     onClick={this.onSubmit} 
                     disabled={this.buttonDisableHandler(this.state.optionChecked)}>
                        Submit
            </button>);

        let isFreeResponseQuestion = this.state.questionType === FEEDBACK_QUESTION_TYPE.FREE_RESPONSE;
        let feedbackTextareaDisabled = !isFreeResponseQuestion && this.state.textboxDisabled;

        return (
            <Feedback
                success_message = {this.state.feedbackStrings["SUCCESS_MESSAGE"]}
                userFirstName = {this.state.userFirstName}
                feedbackQuestion = {this.state.question}
                chooseAllText = {this.state.feedbackStrings["CHOOSE_ALL"]}
                otherFeedbackText = {this.state.otherText} 
                feedbackTextareaOnChange = {(e)=>this.textboxHandler(e)} 
                feedbackTextareaDisabled = {feedbackTextareaDisabled}
                loadingThankyouPage = {this.state.loadingThankyouPage}
                submitButton = {submitButton}
                feedbackOptions = {feedbackOptions}
                translations={this.props.translations}
                isFreeResponseQuestion={isFreeResponseQuestion}
            />
        )
    }
}

export default withLastLocation(FeedbackMain);
